export default __webpack_public_path__ + "static/media/garages.bfeb9434.svg";